import React, { useState, useEffect } from "react";
import { Redirect, useParams } from "react-router-dom";

import { Form, Dropdown } from "semantic-ui-react";

import { producaov2 as api } from "../../../../../services/apis";

import swal from "sweetalert";
import { StyledLabel, StyledButton } from "./styles";
import { contractTypeUtils, utils, workLocation } from "../utils";

const EditVacancyForm = () => {
  const [rolePosition, setRolePosition] = useState("");
  const [modelActuation, setModelActuation] = useState("");
  const [modelContract, setModelContract] = useState("");
  const [location, setLocation] = useState("");
  const [vacancyLink, setVacancyLink] = useState("");
  const [redirect, setRedirect] = useState(false);

  const { id } = useParams();

  console.log(modelContract);

  useEffect(() => {
    const getCompany = async () => {
      await api
        .get(`/voitto-vacancies/${id}`)
        .then(res => {
          setRolePosition(res.data.item.role_position);
          setModelActuation(res.data.item.model);
          setModelContract(res.data.item.type);
          setLocation(res.data.item.location);
          setVacancyLink(res.data.item.vacancy_link);
        })
        .catch(err => {
          swal(
            "Vaga não encontrada",
            `Vaga com id: ${id} não encontrada. Para mais detalhes, contacte TI`,
            "error"
          );
          console.error(err);
        });
    };
    getCompany();
  }, [id]);

  const submitForm = async e => {
    e.preventDefault();
    try {
      await api.put(`voitto-vacancies/${id}`, {
        role_position: rolePosition,
        vacancy_link: vacancyLink,
        model: modelActuation,
        type: modelContract,
        location: location,
      });

      swal("Vaga editada com sucesso", "", "success");
      setRedirect(true);
    } catch (error) {
      swal(
        "Verifique todos os campos",
        "Se o erro persistir, contacte o TI",
        "error"
      );
      console.error("Erro ao enviar formulário:", error);
    }
  };

  return (
    <>
      {redirect && <Redirect to="/admin/rh/vacancies" />}
      <Form>
        <Form.Field>
          <StyledLabel>Nome da Vaga</StyledLabel>
          <Form.Input
            name="name"
            placeholder={rolePosition}
            value={rolePosition}
            onChange={e => setRolePosition(e.target.value)}
          />
        </Form.Field>
        <Form.Field>
          <StyledLabel>Tipo de atuação</StyledLabel>
          <Dropdown
            placeholder="Selecionar"
            value={modelActuation}
            options={utils}
            fluid
            selection
            onChange={e => setModelActuation(e.target.innerText)}
          />
        </Form.Field>
        <Form.Field>
          <StyledLabel>Modelo de contrato</StyledLabel>
          <Dropdown
            placeholder="Selecionar"
            value={modelContract}
            options={contractTypeUtils}
            fluid
            selection
            onChange={e => setModelContract(e.target.innerText)}
          />
        </Form.Field>
        <Form.Field>
          <StyledLabel>Cidade de atuação</StyledLabel>
          <Dropdown
            placeholder="Selecionar"
            value={location}
            options={workLocation}
            fluid
            selection
            onChange={e => setLocation(e.target.innerText)}
          />
        </Form.Field>
        <Form.Field>
          <StyledLabel>Link da vaga na Sólides</StyledLabel>
          <Form.Input
            name="link"
            placeholder="Ex: https://grupovoitto.vagas.solides.com.br/vaga/309565?_...."
            value={vacancyLink}
            onChange={e => setVacancyLink(e.target.value)}
          />
        </Form.Field>

        <StyledButton type="submit" onClick={submitForm}>
          <i class="pencil alternate icon"></i>Editar
        </StyledButton>
      </Form>
    </>
  );
};

export default EditVacancyForm;
